module.exports = __webpack_public_path__ + "assets/img/enterIcon3.f01963a4.png";